module.exports = __webpack_public_path__ + "assets/d71dc3f5041bd59e9e6261d48fa21be0.png";